export const SERVICE_CODE = 'DASHBOARD_ADMIN' + '_SERVICE';
